import get from 'lodash/get';
import set from 'lodash/set';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isArray from 'lodash/isArray';

export const mergeAppStylesWithTheme = (applicationStyles = {}, theme = {}) => {
    Object.keys(applicationStyles).map(key => {
        // Get the value
        let value = get(applicationStyles, key, '');

        // If the value is a string with length, or an array with length, or a number we want to set the value
        // Empty strings and arrays will not be set.
        if (
            (isString(value) && value.length > 0) ||
            (isArray(value) && value.length > 0) ||
            isNumber(value)
        ) {
            // Strings including a pipe character are converted to an array of values delimited by '|'.
            // Arrays of values are used for responsive styles when supplied to a component style prop, but we may not know ahead of time which component theme values we want to be responsive.
            // Using this method we can set responsive styles without having to redefine an application template style as an array.
            if (isString(value) && value.includes('|')) {
                value = value.split('|').map(val => val.trim());
            }

            // Application style keys can be in the form of "Login.bgColor, colors.primary etc", so we update the theme object using the key as the object path.
            set(theme, key, value);
        }
    });

    return theme;
};



// WEBPACK FOOTER //
// ./src/utils/mergeAppStylesWithTheme.ts